export default __webpack_public_path__ + "static/media/dashboard-teamsgrid4.1.4a83cb25.png";